export default __webpack_public_path__ + "static-bigflip/media/logo-big-flip.7b91af89.png";